/**
 * @generated SignedSource<<777346b32900b694debf88f702d5edc6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MigrateListConfigClickListener_JiraProject$data = {
  readonly key: string;
  readonly projectId: string | null | undefined;
  readonly " $fragmentType": "MigrateListConfigClickListener_JiraProject";
};
export type MigrateListConfigClickListener_JiraProject$key = {
  readonly " $data"?: MigrateListConfigClickListener_JiraProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"MigrateListConfigClickListener_JiraProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "MigrateListConfigClickListener_JiraProject",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "f3ad4cc29877caa8f8c8511c066b510d";

export default node;
